import React, {useMemo} from 'react';
import {Form, Icon, Grid, Segment} from 'semantic-ui-react';

const WtsAgendaViewOnly = ({courseToEdit, reduxData}) => {
  const displayData = useMemo(() => {
    if (!courseToEdit || !reduxData) {
      return {
        'concesionarios': [],
        'destinatarios': [],
        'area': 'N/A',
        'cursoNombre': 'Cargando...',
        'observacion': '',
      };
    }

    const courseId = courseToEdit.course_id || courseToEdit.idCursoReferencia;
    const instructorId = courseToEdit.form || courseToEdit.instructor;

    const instructor = (reduxData.instructors || []).find((i) =>
      String(i.id) === String(instructorId) || i.fullName === instructorId,
    );

    const cursoActual = (reduxData.courses || []).find((c) => String(c.id) === String(courseId));
    const status = (reduxData.wtsStatus || []).find((s) => s.code === courseToEdit.status);

    const directedToRaw = courseToEdit.directed_to ||
      courseToEdit.destinatarios ||
      courseToEdit.course_destinatarios ||
      [];

    const directedToIds = directedToRaw.map((d) => {
      if (typeof d === 'object' && d !== null) {
        return String(d.id || d.idCursoDestino || d.course_id_destino);
      }
      return String(d);
    });

    const filteredCourses = (reduxData.courses || []).filter((c) => {
      const isNotCurrent = String(c.id) !== String(courseId);
      const isActive = c.status === 'ACTIVO' || c.status === 'A';
      const sameArea = cursoActual && String(c.courseArea) === String(cursoActual.courseArea);
      return isNotCurrent && isActive && sameArea;
    }).map((c) => ({
      ...c,
      'isPrevio': directedToIds.includes(String(c.id)),
    }));

    const rawDealers = courseToEdit.concesionarios ||
      courseToEdit.dealerParticipants ||
      courseToEdit.agendamiento_concesionarios ||
      [];

    const mappedDealers = rawDealers.map((d) => {
      const officialDealer = (reduxData.wtsDealers || []).find((wd) =>
        String(wd.ruc).trim() === String(d.ruc).trim(),
      );
      return {
        'ruc': d.ruc || '',
        'nombre': officialDealer ?
          officialDealer.description :
          (d.description || d.nombre || 'Concesionario no identificado'),
        'cupos': d.participantes || d.count || d.cupos || 0,
      };
    });

    return {
      'id': courseToEdit.id || '',
      'area': reduxData.areaSelected?.description || cursoActual?.courseArea || 'N/A',
      'cursoNombre': cursoActual ?
        cursoActual.course :
        (courseToEdit.nombre_curso || 'No identificado'),
      'inicio': courseToEdit.start_date || courseToEdit.fechaInicio || '',
      'fin': courseToEdit.end_date || courseToEdit.fechaHasta || '',
      'inscripcion': courseToEdit.inscription_date ||
        courseToEdit.fechaLimiteInscripcion ||
        courseToEdit.date_inscription || '',
      'evaluacion': courseToEdit.evaluation_date ||
        courseToEdit.fechaLimitePrimeraEvaluacion ||
        courseToEdit.date_evaluation || '',
      'instructorNombre': instructor ? instructor.fullName : (instructorId || 'Sin asignar'),
      'experiencia': cursoActual ? `${cursoActual.prerequisite || 0} meses` : '0 meses',
      'estado': status ? status.course_status : (courseToEdit.status || ''),
      'participantes': courseToEdit.participants || courseToEdit.numParticipantes || 0,
      'observacion': courseToEdit.course_observation ||
        courseToEdit.observaciones ||
        cursoActual?.courseObservation || '',
      'concesionarios': mappedDealers,
      'destinatarios': filteredCourses,
    };
  }, [courseToEdit, reduxData]);

  const SectionDivider = ({icon, label}) => (
    <Grid.Row style={{'paddingBottom': '0', 'paddingTop': '1.8em'}}>
      <Grid.Column width={16}>
        <div style={{'display': 'flex', 'alignItems': 'center', 'gap': '12px'}}>
          <div style={{
            'flex': 1, 'height': '2px',
            'background': 'linear-gradient(to right, #0d5a8e, #2185d0)',
          }} />
          <span style={{
            'color': '#fff',
            'fontWeight': 'bold',
            'fontSize': '0.88em',
            'whiteSpace': 'nowrap',
            'backgroundColor': '#0d5a8e',
            'padding': '4px 14px',
            'borderRadius': '20px',
            'letterSpacing': '0.04em',
            'boxShadow': '0 2px 6px rgba(33,133,208,0.35)',
          }}>
            <Icon name={icon} style={{'color': '#a8d8ff', 'marginRight': '6px'}} />{label}
          </span>
          <div style={{
            'flex': 1, 'height': '2px',
            'background': 'linear-gradient(to left, #0d5a8e, #2185d0)',
          }} />
        </div>
      </Grid.Column>
    </Grid.Row>
  );

  const segmentStyle = {
    'backgroundColor': '#f0f7ff',
    'border': '1px solid #a8d4f5',
    'borderLeft': '4px solid #2185d0',
    'borderRadius': '6px',
  };

  return (
    <Form>
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Form.Input label="Departamento" value={displayData.area} readOnly />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label="ID Agenda" value={displayData.id} readOnly />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={16}>
            <Form.Input label="Curso Seleccionado" value={displayData.cursoNombre} readOnly />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={3}>
          <Grid.Column>
            <Form.Input label="Inicio" value={displayData.inicio} readOnly />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label="Fin" value={displayData.fin} readOnly />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label="Fecha límite Inscripción" value={displayData.inscripcion} readOnly />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={3}>
          <Grid.Column>
            <Form.Input label="Fecha Pre Evaluación" value={displayData.evaluacion} readOnly />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label="Instructor" value={displayData.instructorNombre} readOnly />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label="Experiencia" value={displayData.experiencia} readOnly />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={2}>
          <Grid.Column>
            <Form.Input label="Estado Actual" value={displayData.estado} readOnly />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label="Total Participantes" value={displayData.participantes} readOnly />
          </Grid.Column>
        </Grid.Row>

        <SectionDivider icon="user" label="Dirigido A" />

        <Grid.Row style={{'paddingTop': '0.6em'}}>
          <Grid.Column width={16}>
            <Segment style={{'maxHeight': '150px', 'overflowY': 'auto', ...segmentStyle}}>
              {displayData.destinatarios.length > 0 ? (
                displayData.destinatarios.map((c) => (
                  <Form.Checkbox
                    key={c.id}
                    label={c.course || c.description}
                    checked={c.isPrevio}
                    disabled
                    style={{'marginBottom': '8px', 'opacity': '1'}}
                  />
                ))
              ) : (
                <p style={{'textAlign': 'center', 'color': '#999'}}>
                  No hay otros cursos en esta área.
                </p>
              )}
            </Segment>
          </Grid.Column>
        </Grid.Row>

        <SectionDivider icon="building" label="Distribución de Concesionarios" />

        <Grid.Row style={{'paddingTop': '0.6em'}}>
          <Grid.Column width={16}>
            <Segment style={{'maxHeight': '300px', 'overflowY': 'auto', 'padding': '0', ...segmentStyle}}>
              {displayData.concesionarios.length > 0 ? (
                displayData.concesionarios.map((dealer, idx) => (
                  <div key={idx} style={{
                    'display': 'flex',
                    'justifyContent': 'space-between',
                    'alignItems': 'center',
                    'padding': '8px 14px',
                    'borderBottom': idx < displayData.concesionarios.length - 1 ?
                      '1px solid #b8daff' : 'none',
                    'backgroundColor': idx % 2 === 0 ? '#f0f7ff' : '#ddeeff',
                  }}>
                    <span>
                      <Icon name="check circle" style={{'color': '#2185d0'}} />
                      <strong style={{'color': '#2185d0'}}>{dealer.ruc}</strong>
                      <span style={{'color': '#444'}}> - {dealer.nombre}</span>
                    </span>
                    <span style={{
                      'backgroundColor': '#2185d0',
                      'color': '#fff',
                      'borderRadius': '12px',
                      'padding': '2px 12px',
                      'fontSize': '0.85em',
                      'fontWeight': 'bold',
                      'whiteSpace': 'nowrap',
                    }}>
                      {dealer.cupos} cupos
                    </span>
                  </div>
                ))
              ) : (
                <div style={{'textAlign': 'center', 'color': 'grey', 'padding': '16px'}}>
                  No hay concesionarios.
                </div>
              )}
            </Segment>
          </Grid.Column>
        </Grid.Row>

        <SectionDivider icon="file alternate outline" label="Observaciones" />

        <Grid.Row style={{'paddingTop': '0.6em'}}>
          <Grid.Column width={16}>
            <Segment style={{
              'minHeight': '60px',
              'color': '#333',
              'fontStyle': displayData.observacion ? 'normal' : 'italic',
              ...segmentStyle,
            }}>
              {displayData.observacion || 'Sin observaciones.'}
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

export default WtsAgendaViewOnly;
